module.exports = __webpack_public_path__ + "img/blog-12.c686abeb.webp";